import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { IconV2 } from "../../../icon_v2";
const DropdownButtonV2 = ({ label, options, className = "", disabled = false, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return (_jsxs("div", { className: "relative", ref: dropdownRef, children: [_jsxs("button", { onClick: () => !disabled && setIsOpen(!isOpen), disabled: disabled, className: `
          flex min-w-[200px] items-center rounded-lg bg-gradient-to-b
          from-[#007BD9] to-[#005AA1] text-white
          transition-all duration-200
          ${!disabled && "hover:from-[#0070C9] hover:to-[#004F91]"}
          ${disabled && "cursor-not-allowed opacity-50"}
          ${className}
        `, children: [_jsx("span", { className: "px-4 py-2", children: label }), _jsx("div", { className: "h-[24px] w-[1px] bg-white/20" }), _jsx("div", { className: "px-3 py-2", children: _jsx(IconV2, { type: "fa", icon: {
                                icon: ["far", "angle-down"],
                                fixedWidth: true,
                                size: "lg",
                                color: "white",
                            } }) })] }), isOpen && (_jsx("div", { className: "absolute z-10 mt-1 w-full rounded-lg border border-gray-200 bg-white shadow-lg", children: options.map((option, index) => (_jsx("button", { onClick: () => {
                        if (option.disabled === false) {
                            option.onClick();
                            setIsOpen(false);
                        }
                    }, disabled: option.disabled, className: `
                w-full px-4 py-2 text-left first:rounded-t-lg last:rounded-b-lg
                ${option.disabled === true
                        ? "cursor-not-allowed bg-gray-50 text-gray-400"
                        : "text-gray-700 hover:bg-gray-50"}
              `, children: option.label }, index))) }))] }));
};
export default DropdownButtonV2;
